import { client } from "@/main";
import { activeNewsQuery } from "@/graphql/query";

export default {
  async fetchNews({ commit }) {
    try {
      const { data } = await client.query({
        query: activeNewsQuery,
        fetchPolicy: "network-only",
      });
      commit("setNews", data.activeNews);
    } catch (error) {
      console.log(`Could not fetch news: ${error}`);
    }
  },
};
